import PersonasImplicadas from './PersonasImplicadas';

export default PersonasImplicadas;
